/**
 * Sprint V36 (Sa 14.09.2026) — Kern-Zitate pro Fokustyp × Kachel-Kategorie.
 *
 * 1-Satz Take-Away pro Kachel als Gestalt-Anker. Bewusst kurz (6-14 Wörter),
 * ohne Namen des Fokustyps, damit auf allen 3 Routen wiederverwendbar.
 * Fallback-Fenster im Kachel-Component: kein quote -> Zitat-Block wird
 * einfach weggelassen.
 */
export const FOKUSTYP_KERN_ZITATE = {
  katze: {
    verhaltensweisen: "Erst handeln, dann sortieren — das hält dich im Vorlauf.",
    erwartungshaltung: "Klare Ansagen. Kein Rumeiern. Und Respekt für die Geschwindigkeit.",
    erste_impulse: "Wenn's brennt, springst du. Andere überlegen noch.",
    motivation: "Bewegung ist dein Beweis, dass du wirkst.",
    stressmuster: "Unter Druck wirst du kürzer, härter, direkter.",
    werte: "Freiheit, Tempo, sichtbares Ergebnis.",
    blindspots: "Was du an Tempo gewinnst, kann dich an Nuance kosten.",
  },
  eule: {
    verhaltensweisen: "Erst verstehen, dann bewegen — deine Präzision hat einen Preis wert.",
    erwartungshaltung: "Bring Daten, Fakten, klare Argumente. Und lass mich denken.",
    erste_impulse: "Bevor du reagierst, sortierst du. Immer.",
    motivation: "Ordnung erschaffen, wo andere Chaos hinnehmen.",
    stressmuster: "Wenn's eng wird, ziehst du dich in Analyse zurück.",
    werte: "Wahrheit, Klarheit, systemische Präzision.",
    blindspots: "Perfektion kann dich in Details versinken lassen, während die Uhr tickt.",
  },
  biene: {
    verhaltensweisen: "Beziehung geht vor Sachfrage — das ist keine Schwäche, das ist deine Stärke.",
    erwartungshaltung: "Erst der Mensch, dann das Thema. Wertschätzung ist kein Bonus.",
    erste_impulse: "Du liest den Raum, bevor du sprichst.",
    motivation: "Verbundenheit erzeugen — für alle spürbar.",
    stressmuster: "Wenn's kracht, harmonisierst du eher, als dass du eckst.",
    werte: "Vertrauen, Zugehörigkeit, echter Kontakt.",
    blindspots: "Harmoniesucht kann Konflikte verlängern, die du eigentlich lösen willst.",
  },
  hund: {
    verhaltensweisen: "Sicherheit zuerst — dann kann der Rest wachsen.",
    erwartungshaltung: "Verlässlichkeit ist die Währung, in der du zahlst und bezahlt wirst.",
    erste_impulse: "Du prüfst den Boden, bevor du drauftrittst.",
    motivation: "Stabile Umgebung schaffen, in der andere gedeihen.",
    stressmuster: "Wenn's wackelt, klammerst du dich an Bewährtes.",
    werte: "Sicherheit, Verlässlichkeit, Kontinuität.",
    blindspots: "Bewährtes zu halten kann dich blind machen für nötige Veränderung.",
  },
};

/**
 * Liefert das Kern-Zitat fuer einen Fokustyp × Kategorie. Fallback: null.
 */
export function getKernZitat(slug, category) {
  const s = String(slug || "").toLowerCase();
  const table = FOKUSTYP_KERN_ZITATE[s];
  if (!table) return null;
  return table[category] || null;
}
